import AppErrorBoundary from './AppErrorBoundary';

export default AppErrorBoundary;
